module.exports = __webpack_public_path__ + "static/media/crocoplay.4b798986.png";